import { useEffect } from 'react';
import { t } from '@lingui/macro';
import AnalyticsManager from './analytics/manager';

const policyLinkObject = {
  en: '/en/terms-and-conditions',
  se: '/se/villkor',
  fi: '/fi/ehdot',
  no: '/no/vilkar',
};

export const GlowCookies = ({ currentUser, locale }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window['ygpAnalytics'] = AnalyticsManager();
    }
  }, []);

  return !currentUser ? (
    <>
      <script src="https://cdn.jsdelivr.net/gh/manucaralmo/GlowCookies@3.1.7/src/glowCookies.min.js"></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
                window.addEventListener("DOMContentLoaded", function(){
                  glowCookies.start("${locale}", {
                    style: 1,
                    policyLink: "${policyLinkObject[locale]}",
                    position: 'right',
                    hideAfterClick: true,
                    bannerHeading: "${t({ id: 'consent.cookies.title' })}",
                    bannerDescription: "${t({ id: 'consent.cookies.desc' })}",
                    acceptBtnText: "${t({ id: 'consent.cookies.accept' })}",
                    rejectBtnText: "${t({ id: 'consent.cookies.reject' })}",
                    bannerLinkText: "${t({ id: 'consent.cookies.read_more' })}",
                    acceptBtnBackground: "#56b9e5",
                    customScript: [{ type: 'custom', position: 'body', content: "window.ygpAnalytics && window.ygpAnalytics.initLibraries({})" }, {type: "custom", position: 'body', content: "document.cookie = 'GlowCookies=1';"}]
                 });
                });
              `,
        }}
      />
    </>
  ) : null;
};
